<div *ngIf="showModal" class="modal-container absolute z-50 border-r-8 top-0 left-0 w-full h-full bg-gray-900 bg-opacity-50 flex justify-center items-center">
  <div class="modal-content bg-black dark:bg-white p-4 text-white dark:text-black w-1/4 border border-primary">
    <h2 class="text-center text-3xl font-bold text-white dark:text-black pb-4">
      Editar Vehículo <br />
      🚗🏍️
    </h2>

    <form [formGroup]="vehicleForm" (ngSubmit)="updateVehicle()">
      <div class="flex flex-wrap md:flex-nowrap gap-4 mb-4">
        <select type="text" formControlName="typevehicle" class="form-input ltr:pl-10 rtl:pr-10">
          <option value="" disabled selected>Selecciona el tipo de vehiculo</option>
          <option value="auto">CARRO</option>
          <option value="moto">MOTO</option>
          <option value="camioneta">CAMIONETA</option>
          <option value="camion">CAMIÓN</option>
          <option value="bicicleta">BICICLETA</option>
        </select>
        <div *ngIf="vehicleForm.get('typevehicle')?.invalid && vehicleForm.get('typevehicle')?.touched" class="text-red-500">
          <small *ngIf="vehicleForm.get('typevehicle')?.errors?.['required']"> Ingresa tipo de vehiculo </small>
        </div>
      </div>

      <div class="flex flex-wrap md:flex-nowrap gap-4 mb-4">
        <div class="half w-full md:w-1/2">
          <input type="text" formControlName="marca" placeholder="Marca" class="form-input ltr:pl-10 rtl:pr-10" />
          <div *ngIf="vehicleForm.get('marca')?.invalid && vehicleForm.get('marca')?.touched" class="text-red-500">
            <small *ngIf="vehicleForm.get('marca')?.errors?.['required']"> Ingresa la marca </small>
          </div>
        </div>

        <!-- Campo: Modelo -->
        <div class="half w-full md:w-1/2">
          <input type="text" formControlName="modelo" placeholder="Modelo" class="form-input ltr:pl-10 rtl:pr-10" />
          <div *ngIf="vehicleForm.get('modelo')?.invalid && vehicleForm.get('modelo')?.touched" class="text-red-500">
            <small *ngIf="vehicleForm.get('modelo')?.errors?.['required']"> Ingresa el modelo </small>
          </div>
        </div>
      </div>

      <!-- Campo: Año -->
      <div class="flex flex-wrap md:flex-nowrap gap-4">
        <div class="half w-full md:w-1/2">
          <input type="number" formControlName="km" placeholder="Kilometraje" class="form-input ltr:pl-10 rtl:pr-10" />
          <div *ngIf="vehicleForm.get('km')?.invalid && vehicleForm.get('km')?.touched" class="text-red-500">
            <small *ngIf="vehicleForm.get('km')?.errors?.['required']"> Ingresa el kilometraje </small>
          </div>
        </div>

        <!-- Campo: Placa -->
        <div class="half w-full md:w-1/2">
          <input type="text" formControlName="plate" placeholder="placa" class="form-input ltr:pl-10 rtl:pr-10" />
          <div *ngIf="vehicleForm.get('plate')?.invalid && vehicleForm.get('plate')?.touched" class="text-red-500">
            <small *ngIf="vehicleForm.get('plate')?.errors?.['required']"> Ingresa la placa </small>
          </div>
        </div>
      </div>
      <div class="flex flex-wrap md:flex-nowrap gap-4">
        <div class="half w-full md:w-1/2 pt-4">
          <input type="text" formControlName="year" placeholder="Año" class="form-input ltr:pl-10 rtl:pr-10" />
          <div *ngIf="vehicleForm.get('year')?.invalid && vehicleForm.get('year')?.touched" class="text-red-500">
            <small *ngIf="vehicleForm.get('year')?.errors?.['required']"> Ingresa el año </small>
          </div>
        </div>

        <div class="half w-full md:w-1/2 pt-4">
          <input type="text" formControlName="city" placeholder="Ciudad" class="form-input ltr:pl-10 rtl:pr-10" />
          <div *ngIf="vehicleForm.get('city')?.invalid && vehicleForm.get('city')?.touched" class="text-red-500">
            <small *ngIf="vehicleForm.get('city')?.errors?.['required']"> Ingresa la ciudad </small>
          </div>
        </div>
      </div>
      <div class="relative mb-4 mt-4">
        <input type="text" id="color" formControlName="color" readonly placeholder="Selecciona el color de tu vehiculo" class="form-input cursor-pointer" />
        <p class="text-xs text-gray-500 mt-1">Haz clic en un círculo para seleccionar el color</p>
        <!-- Opciones de color en forma de círculos -->
        <div class="flex gap-2 mt-2">
          <button
            type="button"
            (click)="selectColor('ROJO')"
            [ngClass]="{ 'ring-2 ring-offset-2 ring-blue-500 border border-primary': vehicleForm.get('color')?.value === 'ROJO' }"
            class="w-8 h-8 rounded-full bg-red-500"
          ></button>
          <button
            type="button"
            (click)="selectColor('VERDE')"
            [ngClass]="{ 'ring-2 ring-offset-2 ring-blue-500': vehicleForm.get('color')?.value === 'VERDE' }"
            class="w-8 h-8 rounded-full bg-green-500 border border-primary"
          ></button>
          <button
            type="button"
            (click)="selectColor('AMARILLO')"
            [ngClass]="{ 'ring-2 ring-offset-2 ring-blue-500': vehicleForm.get('color')?.value === 'AMARILLO' }"
            class="w-8 h-8 rounded-full bg-yellow-500 border border-primary"
          ></button>
          <button
            type="button"
            (click)="selectColor('AZUL')"
            [ngClass]="{ 'ring-2 ring-offset-2 ring-blue-500': vehicleForm.get('color')?.value === 'AZUL' }"
            class="w-8 h-8 rounded-full bg-blue-500 border border-primary"
          ></button>
          <button
            type="button"
            (click)="selectColor('NEGRO')"
            [ngClass]="{ 'ring-2 ring-offset-2 ring-blue-500': vehicleForm.get('color')?.value === 'NEGRO' }"
            class="w-8 h-8 rounded-full bg-black border border-primary"
          ></button>
          <button
            type="button"
            (click)="selectColor('BLANCO')"
            [ngClass]="{ 'ring-2 ring-offset-2 ring-blue-500': vehicleForm.get('color')?.value === 'BLANCO' }"
            class="w-8 h-8 rounded-full bg-white border border-primary"
          ></button>
        </div>
      </div>
      <div class="flex justify-end gap-2 mt-4">
        <button type="submit" class="btn btn-primary px-4 py-2" [disabled]="vehicleForm.invalid">Actualizar</button>
        <button type="button" class="btn btn-secondary px-4 py-2" (click)="close.emit()">Cancelar</button>
      </div>
    </form>
  </div>
</div>
